import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Visitor } from "../../../../model/visitor";
import { VisitorService } from "../../../../services/visitor.service";
import { ModalComponent } from "../modal.component/modal.component";

@Component({
  selector: "welcome-modal-simple",
  templateUrl: "./welcome-modal-simple.component.html",
  styleUrls: ["./welcome-modal-simple.component.scss"],
})
export class WelcomeModalSimpleComponent {
  @ViewChild("modal") public modal: ModalComponent;
  @Output() public close = new EventEmitter();

  public visitor: Visitor;
  public modelValid: boolean;
  public customerIsNew = true;

  constructor(private visitorService: VisitorService, private router: Router) {
    this.visitor = this.visitorService.getVisitor();
  }

  public open() {
    var jwt = sessionStorage.getItem('jwt');

    if(jwt)
    {
      this.modal.open(false);
    }
  }

  public onNewCustomerClicked() {
    this.saveVisitor();
    this.closeModal(`'New customer' clicked`);
  }

  public async onExistingCustomerClicked(): Promise<void> {
    this.router.navigateByUrl("/min-side");
  }

  public closeModal(source: string) {
    if (this.modal == null) return;

    this.modal.close(source);
    this.close.emit();
  }

  private saveVisitor() {
    //const visitorMaskedCpr = this.visitorService.maskCprCheckDigits(this.visitor);
    this.visitorService.commitVisitor(this.visitor);
  }

}
